__turbopack_context__.v({
  "fade-in": "_8oBgdW_fade-in",
  "spin-in": "_8oBgdW_spin-in",
  "spinner": "_8oBgdW_spinner",
  "svg-wrapper": "_8oBgdW_svg-wrapper",
  "text": "_8oBgdW_text",
});
